export const subtitles = {
    "1": {
        "startTime": 6.0,
        "endTime": 7.0,
        "transcript": "Kitak' qanraqaa.",
        "translation": "Please speak."
    },
    "2": {
        "startTime": 7.8,
        "endTime": 11.5,
        "transcript": "Tua-llu-q' tua-i qaill' ayuqeqatarta qanaallerpuk?",
        "translation": "What's our conversation going to be like?"
    },
    "3": {
        "startTime": 16.9,
        "endTime": 22.0,
        "transcript": "Assirciqnganani-q' tua-i piuq tuani massiinaam iluani?",
        "translation": "Does it seem like it'll be good in that machine?"
    },
    "4": {
        "startTime": 40.5,
        "endTime": 52.0,
        "transcript": "Tua-i-w' taklirinrilengraan-llu antarkaten aneskuvki egmianun camek nagutaunak.",
        "translation": "Even if it's not too long, you can say what you have to say without lingering on anything."
    },
    "5": {
        "startTime": 52.5,
        "endTime": 54.0,
        "transcript": "Assirtuq, canrituq.",
        "translation": "It's good, it's fine."
    },
    "6": {
        "startTime": 58.5,
        "endTime": 71.0,
        "transcript": "Wiinga-wa ellangellemkun elpe'ngllemkun qanaalalrianga.",
        "translation": "I only speak of my earliest memories and what I've realized."
    },
    "7": {
        "startTime": 72.0,
        "endTime": 80.0,
        "transcript": "Cali-llu maa-i-am elpengukut wangkuta tegganerni",
        "translation": "Also, we elders have realized now"
    },
    "8": {
        "startTime": 81.5,
        "endTime": 91.0,
        "transcript": "Maaten elpengukut nunavut man'a nakmiin nunavut pikenrilriatun ayuqlirillrullinikvut.",
        "translation": "We realized that it's like we don't own our land here, our very own land, anymore."
    },
    "9": {
        "startTime": 92.9,
        "endTime": 98.0,
        "transcript": "Maani tua-i nunamteńi umyugiurngairulluta.",
        "translation": "We don't do what we want on our land anymore."
    },
    "10": {
        "startTime": 98.5,
        "endTime": 107.5,
        "transcript": "Tuamta-ll' cali maani unani mer'utemteńi umyugiurngaunata.",
        "translation": "And then, we can't do what we want in our waters either."
    },
    "11": {
        "startTime": 108.0,
        "endTime": 117.5,
        "transcript": "Tau͡gaam wani wii qaillun umyuartequralartua ukegkut yuugarkat umyuaqaqamki.",
        "translation": "But I do have some ideas when I think about the people who will live in the future."
    },
    "12": {
        "startTime": 118.0,
        "endTime": 130.5,
        "transcript": "Wangkuta waten ellilriani camun amlleret allrakut tekilluki maktangaitukut naucetaaruamta yugni.",
        "translation": "We who have become like this will not be standing for many years because we people are [like] flowers."
    },
    "13": {
        "startTime": 132.5,
        "endTime": 139.4,
        "transcript": "Kingunerput tuaten nauluni. Tamakut tuaten naulriit ciunret piunrirluni.",
        "translation": "Our offspring grow too. Those first ones who grow pass away."
    },
    "14": {
        "startTime": 139.5,
        "endTime": 141.0,
        "transcript": "Tamana piciuguq.",
        "translation": "That's true."
    },
    "15": {
        "startTime": 142.5,
        "endTime": 146.0,
        "transcript": "Mat'umek wani umyuartequralartua:",
        "translation": "I always think about this:"
    },
    "16": {
        "startTime": 146.9,
        "endTime": 156.5,
        "transcript": "Uani Naparyarrarni tayima 1971-aam tungiini Kass'aq tekiteqarraalleq waten qanellruuq:",
        "translation": "Downriver in Napakiak, probably around 1971, a Caucasian who came for the first time said this:"
    },
    "17": {
        "startTime": 157.5,
        "endTime": 164.0,
        "transcript": "Pissuryaramteńek-gguq cuqcirinrilkumta nunakaitukut.",
        "translation": "If we don't determine our hunting grounds, we won't have any land."
    },
    "18": {
        "startTime": 165.0,
        "endTime": 174.0,
        "transcript": "Tuani-llu inerquryaaqekenka maligutesqevkenaki tamakunun allotment-aatnun. Cunawa.",
        "translation": "And at the time, I admonished them against following those allotments. Turns out [I was right]."
    },
    "19": {
        "startTime": 175.0,
        "endTime": 182.0,
        "transcript": "Uumiani taum kevgaq tekitenqigtellria qanertuq waten:",
        "translation": "Shortly after, that representative arrived again and said this:"
    },
    "20": {
        "startTime": 184.0,
        "endTime": 188.5,
        "transcript": "Nuna-gguq man'a patuluku Kass'at taiqatartut.",
        "translation": "Caucasians are going to come and cover this land."
    },
    "21": {
        "startTime": 188.6,
        "endTime": 193.5,
        "transcript": "Tamatumek-gguq pilinrilkumta nunakaitukut pissurvigkaunata-llu.",
        "translation": "[S]he said that if we don't do that, we will have no lands or hunting grounds."
    },
    "22": {
        "startTime": 194.0,
        "endTime": 200.5,
        "transcript": "Akleng, ukveu͡rlurluta-am wangkuta allotment-aanek qaqiutellinilriakut.",
        "translation": "Pity, we believed and established allotments."
    },
    "23": {
        "startTime": 202.7,
        "endTime": 206.5,
        "transcript": "Tuamta-llu maaten ellangukut taum kinguani",
        "translation": "And then we realized after that"
    },
    "24": {
        "startTime": 207.9,
        "endTime": 219.5,
        "transcript": "Makut wani irniaput tutgaraput-llu maaken wangkutnek cataunateng, imkut tua-i kenkataput nutem.",
        "translation": "That our children and grandchildren have nothing from here from us, the ones we've always loved."
    },
    "25": {
        "startTime": 222.5,
        "endTime": 229.0,
        "transcript": "Ukunun aipamteńun tun'aput-qaa? Pikiutekaput-qaa?",
        "translation": "Did we give them to our [Caucasian] counterparts? Did we give it to them?"
    },
    "26": {
        "startTime": 230.0,
        "endTime": 232.5,
        "transcript": "Tua-llu-w' umyuartequralalrianga waten:",
        "translation": "And then I think like this:"
    },
    "27": {
        "startTime": 234.4,
        "endTime": 250.0,
        "transcript": "Wangkuta-mi tegganernun, tegganerni wall'u vote-aryugngalriani nangkumta caqatarta man'a?",
        "translation": "When we elders, we elders or those who can vote, are gone, what's going to happen to this?"
    },
    "28": {
        "startTime": 250.5,
        "endTime": 254.0,
        "transcript": "Kia maktatqatartau yuuyaramta tungiinun?",
        "translation": "Who's going to uphold it to our way of life?"
    },
    "29": {
        "startTime": 255.8,
        "endTime": 260.3,
        "transcript": "Cuqtellemni wii kia maktasngaitellinii.",
        "translation": "By my estimate, no one will uphold them."
    },
    "30": {
        "startTime": 261.0,
        "endTime": 269.0,
        "transcript": "Tamakut-llu irniamta Yuunge'rmeng maktasngaitelliniluku tamana ciumuruskunegteggu.",
        "translation": "And even though our children are Yupiit, they won't uphold it when they go forward with it."
    },
    "31": {
        "startTime": 270.0,
        "endTime": 278.0,
        "transcript": "Tuamta-ll' cali waniw' qaneryararkaqa yuut amlleret assikenritaat.",
        "translation": "And then, a lot of people don't like my advice."
    },
    "32": {
        "startTime": 279.8,
        "endTime": 288.0,
        "transcript": "Yuut-llu amlleret nall'artevkenaki tayima qanaaciqngatua.",
        "translation": "I may not speak correctly about many people."
    },
    "33": {
        "startTime": 288.8,
        "endTime": 296.0,
        "transcript": "Waten niitukut, niitellruunga wii qangvaurtellria ukaqvaggun:",
        "translation": "We heard, I personally heard recently some time ago:"
    },
    "34": {
        "startTime": 300.0,
        "endTime": 308.0,
        "transcript": "Yup'ik Nation-aarurrluta-gguq wangkuta yuullemteńun ayagciqukut.",
        "translation": "If we become the Yup'ik Nation, we will proceed to our way of life."
    },
    "35": {
        "startTime": 311.0,
        "endTime": 316.5,
        "transcript": "Maaten tang, maaten tang tamana wii yuvri'rqa",
        "translation": "I examined it and realized"
    },
    "36": {
        "startTime": 317.5,
        "endTime": 332.0,
        "transcript": "Yup'ik Nation-aaruluta natmun yuuyaramta tungiinun ayagngaitellinilriakut tau͡gaam uungukumta traditional-aaruluta.",
        "translation": "That if we're the Yup'ik Nation, we will not go anywhere with our way of life, but only if we are traditional."
    },
    "37": {
        "startTime": 333.9,
        "endTime": 344.0,
        "transcript": "Traditional-aarukumta Kass'amek atanrunata, wangkutnek tau͡gaam ataniurluta ciungani pillemcetun.",
        "translation": "If we are traditional with no Caucasian governers, but govern ourselves as we did in the past."
    },
    "38": {
        "startTime": 344.9,
        "endTime": 358.0,
        "transcript": "Man'a-llu allotment-aaq maa-i unuamek nepngurtuq Yugnun tauna elliin nunautekniluku.",
        "translation": "And this allotment has become a cause for unrest for Yupiit today who claim they own that land."
    },
    "39": {
        "startTime": 360.0,
        "endTime": 368.0,
        "transcript": "Man'a maa-i tamamta taringumayaaqerput: nepngurutnguuq nunautengqelleq.",
        "translation": "Wr all understand this: land ownership leads to unrest."
    },
    "40": {
        "startTime": 368.7,
        "endTime": 382.5,
        "transcript": "Tau͡gaam nunamek waten angtuarpagmek cet'riluci akmavet qanerluci pisqumalaryaaqamci.",
        "translation": "However, I want youpl to outline a huge area of land like this and speak of it to [non-Yup'ik people] out there."
    },
    "41": {
        "startTime": 383.0,
        "endTime": 387.0,
        "transcript": "Umyuaqa qanlaryaaquq tuaten pisqumaluci.",
        "translation": "I say in my mind that I want youpl to do that."
    },
    "42": {
        "startTime": 388.0,
        "endTime": 393.8,
        "transcript": "Waniwa akmavet igallruunga allragni.",
        "translation": "Last year, I wrote to them out of state."
    },
    "43": {
        "startTime": 394.5,
        "endTime": 410.0,
        "transcript": "Waniwa-llu tutgarama elliin ayagcetelqeńgamiu tamana wani iqukarrluku qanresqumiinga qanertua.",
        "translation": "And I am speaking of it because my grandchild sent it and wanted me to end it with that."
    },
    "44": {
        "startTime": 412.0,
        "endTime": 424.0,
        "transcript": "Waten qanellruunga, amllerrsaaquq qanelqa, ellangellruniluta yup'ut tutgaraput-llu tayima tamariniluki.",
        "translation": "I've said this, I've said a lot, that since our earliest memories, our children and grandchildren are lost."
    },
    "45": {
        "startTime": 424.5,
        "endTime": 434.0,
        "transcript": "Tuamta-ll' cali tamariniluta nunamteńi maani allanrulriatun ellirluta.",
        "translation": "And I say that we are lost in out own lans as if we've become outsiders."
    },
    "46": {
        "startTime": 434.9,
        "endTime": 444.5,
        "transcript": "Nuna-llu man'a umyugiurutkescigaliniluku ak'a. Tuar allanruluta.",
        "translation": "We've already become unable to do what we want on this land. It's like we're outsiders."
    },
    "47": {
        "startTime": 445.8,
        "endTime": 457.0,
        "transcript": "Kitaki tamana arenqiakekumteggu, ilumun arenqiakekumteggu traditional-aaq tau͡gaam tangerrnaurput.",
        "translation": "Now, if we disapprove of that, if we truly disapprove of that, let us look at the traditional [way of life]."
    },
    "48": {
        "startTime": 458.0,
        "endTime": 462.0,
        "transcript": "Waniwa amlleret usviilkeciqaatnga.",
        "translation": "Many will call me crazy now."
    },
    "49": {
        "startTime": 463.0,
        "endTime": 474.0,
        "transcript": "Yup'ik Nation-aaruluta ayakumta akmaken Kass'anek ataniurterluta ayagciqukut.",
        "translation": "If we go forth as the Yup'ik Nation, we will be governed by Caucasians from out there."
    },
    "50": {
        "startTime": 475.8,
        "endTime": 481.0,
        "transcript": "Atam cuq'erteqernaurput. Ak'a AVCP-m ataniraakut.",
        "translation": "Let's gauge the situation. AVCP already governs us."
    },
    "51": {
        "startTime": 483.0,
        "endTime": 494.0,
        "transcript": "Ayagcuutekamteńek-llu Yup'igkun kalikat taqumarillriit tayima tamakut aturluki ayaasqelluta.",
        "translation": "Official documents have been established to go as Yupiit and we are told to go forth with those."
    },
    "52": {
        "startTime": 495.4,
        "endTime": 499.5,
        "transcript": "Tamaa-i tang Kass'akun ayagaarkat, ayagarkat.",
        "translation": "That is the way to go as Westernized [people]."
    },
    "53": {
        "startTime": 499.6,
        "endTime": 507.0,
        "transcript": "Una tau͡gaam traditional-aaq ellminek piugarkaq, ellminek piyullermikun ayagarkaq.",
        "translation": "But the traditional [way of life] is for us to be ourselves, so we can go forth as we want."
    },
    "54": {
        "startTime": 508.0,
        "endTime": 516.5,
        "transcript": "Umyuama wii cucuksaaqaa nutem tamana ellangutkellruamku avaken ayagluku.",
        "translation": "In my opinion, I prefer that because it has been part of my earliest memories from long ago."
    },
    "55": {
        "startTime": 517.0,
        "endTime": 524.0,
        "transcript": "Nunarraat kitumek atanrunateng. Ilameggnek tau͡gaam tegganermek atanerluteng pillruut tamarmeng.",
        "translation": "Villages didn't have governers. All of them were only governed by one of their own elders."
    },
    "56": {
        "startTime": 525.8,
        "endTime": 537.0,
        "transcript": "Mat'umek wani amllenrilengraan tutgarama umyugaa narurcuumiilamku qanqertua.",
        "translation": "Even though it's not a lot, I'm speaking about it because I don't want to disregard my grandchild's opinion."
    },
    "57": {
        "startTime": 539.5,
        "endTime": 542.0,
        "transcript": "Tua-llu qaill' ayuqa man'a elpeni?",
        "translation": "How does this seem to you?"
    },
    "58": {
        "startTime": 547.0,
        "endTime": 550.5,
        "transcript": "[?] Assirtuq. I like it.",
        "translation": "[?] It's good. I like it."
    },
    "59": {
        "startTime": 553.5,
        "endTime": 556.0,
        "transcript": "Yuungnaqellminun-wa tua-i tungiinun.",
        "translation": "About how one should traditionally live."
    },
    "60": {
        "startTime": 559.0,
        "endTime": 578.5,
        "transcript": "Man'a cali tutgarama-am tukriarucaku tayima amlleq nallungramku tau͡gaam ellmacuar tangrrucimtun, nallunrilucimtun.",
        "translation": "Because my grandchild also brought this up, even if I don't know a lot, [I'm speaking] only about what little I understand and know."
    },
    "61": {
        "startTime": 579.5,
        "endTime": 583.0,
        "transcript": "Tua-i ellmacuar tangerqallruaqa wiinga.",
        "translation": "I only saw a little of it."
    },
    "62": {
        "startTime": 583.5,
        "endTime": 594.0,
        "transcript": "Wangkuta-wa tangerqallruarput man'a apyutii maaggun carugarnek tangenrritlemteggun",
        "translation": "We saw what [s]he asked about through how we didn't see a lot of these [Western] things"
    },
    "63": {
        "startTime": 594.9,
        "endTime": 600.0,
        "transcript": "Canek piinata anglillerni tamamta.",
        "translation": "All of us who have grown up without anything [Western]."
    },
    "64": {
        "startTime": 601.0,
        "endTime": 610.5,
        "transcript": "Tua-llu uumek waten aptaanga: wangkutnek-gguq piurqumta qaillun-gguq yuullerput ayagciqa?",
        "translation": "And then [s]he asked me this: if we [govern] ourselves, how will our lives go?"
    },
    "65": {
        "startTime": 612.8,
        "endTime": 630.0,
        "transcript": "Kiuyugngaaqa uumek: ciulirneret tau͡gaam ellangviullruut ciulirnerem alerquutiikun ayagluni.",
        "translation": "I can answer with this: the ancestors were the only ones to grow up with, going though what the ancestors instructed."
    },
    "66": {
        "startTime": 631.0,
        "endTime": 636.0,
        "transcript": "Ciulirnerem-llu alerquutiikun anguss[aagluteng]…",
        "translation": "[They] also hunted with the ancestors' instruction…"
    },
    "67": {
        "startTime": 642.0,
        "endTime": 650.0,
        "transcript": "Kitak' cali apyutkellrat ataam cali tailluku ayagnirniartuten.",
        "translation": "Now, start by bringing up what they asked."
    },
    "68": {
        "startTime": 654.8,
        "endTime": 659.4,
        "transcript": "Yaavet-qaa ekumanrilnguq ilakevkenaku iqulirluku?",
        "translation": "Leave out what's not recorded in there and finish it?"
    },
    "69": {
        "startTime": 659.5,
        "endTime": 667.5,
        "transcript": "Yaa, kitak' au͡gna ataam [qane]llren apyutkellra tailluku cali ataam ayagnirluten.",
        "translation": "Yes, please start by bringing up what you [said] about his question."
    },
    "70": {
        "startTime": 670.0,
        "endTime": 678.0,
        "transcript": "Ii-i, yaa, au͡g'umek-wa natmun arulailqa uunguciircamku. (Canrituq. Ayagnirluten.)",
        "translation": "Okay, yes, I have no idea where I stopped. (It's okay. Just start.)"
    },
    "71": {
        "startTime": 678.9,
        "endTime": 694.0,
        "transcript": "Uumek wani tutgarama apcanga qaillun Yuut ellmeggnek ellmeggnek piurquneng ayakuneng pillerkaanek aplua.",
        "translation": "When my grandchild asked me, [s]he asked about what will happen if Yupiit governed themselves."
    },
    "72": {
        "startTime": 695.0,
        "endTime": 703.0,
        "transcript": "Apcanga tamalkuan nallunrilengramku tau͡gaam tua-i ellma nallunrilamku",
        "translation": "When [s]he asked, even though I [don't] know everything since I only know a little"
    },
    "73": {
        "startTime": 705.0,
        "endTime": 713.5,
        "transcript": "Kiima-w' nallunritenritaqa. Ilama-llu nallunritaat waten carugarnun ellangellrunrilngurni.",
        "translation": "I'm not the only one who knows. My peers who did not grow up with a lot of [Western] things like this know it."
    },
    "74": {
        "startTime": 714.5,
        "endTime": 727.5,
        "transcript": "Qanruyuteput tua-i niitengnaqluki atungnaqluki-llu pilallruamta imumi camek allamek akirugarmek piitellemteńi.",
        "translation": "We tried to obey and adhere to our traditional wisdom back when we didn't have a lot of things including money."
    },
    "75": {
        "startTime": 728.0,
        "endTime": 736.5,
        "transcript": "Tua-llu? Ukutgun tau͡gaam yuk ayagarkauguq ciulirnerteggun.",
        "translation": "You see? A person must only go forth [with the wisdom of] the ancestors."
    },
    "76": {
        "startTime": 737.0,
        "endTime": 747.0,
        "transcript": "Ciulirneret, ciulerneq taillruuq nutarauvkenani, nutem piuluni, nutem qanruyutnguluni.",
        "translation": "The elder did not come as a new thing, [but] as an ancient thing, ancient traditional wisdom."
    },
    "77": {
        "startTime": 748.0,
        "endTime": 756.5,
        "transcript": "Ukut-llu munallruluteng neq'liurteput, neqmun alerquuteput.",
        "translation": "And those who worked on fish for us were dexterous, those who instructed us on fish."
    },
    "78": {
        "startTime": 757.8,
        "endTime": 770.0,
        "transcript": "Waten alerquumaluta: neqmek neqallermek-llu sagciluta pisqevkenata kumiviitellemteńi.",
        "translation": "We were instructed like this: do not make a mess of food and food scras when we didn't have freezers."
    },
    "79": {
        "startTime": 770.9,
        "endTime": 779.0,
        "transcript": "Cuqluku-llu una ulligcista. Cuqluku taqtuluta.",
        "translation": "And it depends on the fish cutter. We stopped depending on her."
    },
    "80": {
        "startTime": 779.9,
        "endTime": 785.0,
        "transcript": "Tua-i apqiitnek spoil-ararkanek piyuunata.",
        "translation": "We wouldn't [gather] what would spoil, as they say [in English]."
    },
    "81": {
        "startTime": 785.7,
        "endTime": 797.0,
        "transcript": "Tuamta-llu ciulirneret alerquutiitgun nunami pekluta. Ciulirneret tau͡gaam alerquutiitgun.",
        "translation": "And then we also walked on land as the ancestors instructed. Only though the ancestors' instruction."
    },
    "82": {
        "startTime": 799.0,
        "endTime": 806.5,
        "transcript": "Arcaqerluku alerquun niisngangnaqluku uskuarmi up'nerkami-llu.",
        "translation": "We especially tried to obey instruction in the fall and spring."
    },
    "83": {
        "startTime": 807.4,
        "endTime": 813.5,
        "transcript": "Tua-i taukuk aarnarqellriaruan nunam qainga mer'et-llu makut qaingat.",
        "translation": "It was because the land and the water were dangerous in those2 times."
    },
    "84": {
        "startTime": 814.5,
        "endTime": 823.4,
        "transcript": "Taukugni aarnaqngan tamakunek arcaqerluta ciulirnerem alerqualallruakut tamatumek.",
        "translation": "Because it was dangerous in those2 times, our ancestors especially instructed us on those."
    },
    "85": {
        "startTime": 823.5,
        "endTime": 831.5,
        "transcript": "Tuamta-llu yuullerkamteńek mat'umek ilamteńun makunun yugnun yuullerkamteńek",
        "translation": "And then about how we should live, how we should live treated our fellow people"
    },
    "86": {
        "startTime": 832.5,
        "endTime": 836.5,
        "transcript": "Yuunitekluta pisqevkenata inerquumaluta.",
        "translation": "They told admonished us against [treating them badly] just because we're people."
    },
    "87": {
        "startTime": 837.0,
        "endTime": 845.0,
        "transcript": "Tamatum nalliini taringumallrunricaaqerput wangkuta man'a tau͡gaam kinguqvaarni elpekellruarput.",
        "translation": "We didn't understand this at the time, but we realized what it was later."
    },
    "88": {
        "startTime": 845.5,
        "endTime": 852.0,
        "transcript": "Una wani yuunitekluni yuuyaraq waten ayuqelliniuq:",
        "translation": "Living life [treating others badly] just because we're people is like this:"
    },
    "89": {
        "startTime": 853.5,
        "endTime": 863.0,
        "transcript": "Yuunitekluni-gguq yuulria qaneni negtaayuitaa ilaminun, cangayullerkaa-llu yuum umyuaqevkenaku.",
        "translation": "A person [who treats others badly] just because he's a person does not watch what he says to other people, and gives no consideration about offending them."
    },
    "90": {
        "startTime": 863.5,
        "endTime": 868.7,
        "transcript": "Cali-llu kenekmek piitelliniluni, umyuaqegtaarmek-llu piitelliniluni.",
        "translation": "He also does not have love or good thoughts."
    },
    "91": {
        "startTime": 869.0,
        "endTime": 875.5,
        "transcript": "Tuaten-llu ayuqellria apqiitnek erneq aipirluku unguvayuunani-gguq.",
        "translation": "They say that one who is like that does not live another day, as they say."
    },
    "92": {
        "startTime": 877.0,
        "endTime": 884.0,
        "transcript": "Taumek tamakut wangkuta teggutekaput tamaa-i",
        "translation": "Those are our sources of support"
    },
    "93": {
        "startTime": 886.5,
        "endTime": 895.0,
        "transcript": "Makunek kalikarteggun ayangvailemta, kalikam mat'um ayangvailgakut.",
        "translation": "Before we started going with these books, before these books started dictating us."
    },
    "94": {
        "startTime": 896.5,
        "endTime": 900.0,
        "transcript": "Naklegnarqellria takumcunaqluku.",
        "translation": "We had mercy on someone pitiful."
    },
    "95": {
        "startTime": 900.5,
        "endTime": 909.5,
        "transcript": "Cali-llu man'a wani naklekutvut aturyugnaunaku state-aq pingqelliniuq waten:",
        "translation": "Also, the state apprently has this without our compassion:"
    },
    "96": {
        "startTime": 912.8,
        "endTime": 920.0,
        "transcript": "Eighteen-aaqan-gguq yuum yun'i peggliu qanrutenrirluku, allakaan-llu yuuvkarluku.",
        "translation": "A person should abondon his child when he's 18, stop teaching him, and have him live separately."
    },
    "97": {
        "startTime": 921.8,
        "endTime": 925.0,
        "transcript": "Tamana wangkuta alerquutekenritarput Yugni.",
        "translation": "That is not how we Yupiit are instructed."
    },
    "98": {
        "startTime": 926.0,
        "endTime": 939.0,
        "transcript": "Yuum-gguq angukara'urluurteng'e'rmi, panini-ll' ak'allaurtengraan, qetunrani-ll' ak'allaurtengraan iqlutun cingyuitaa.",
        "translation": "They say that even when a person becomes an old man, though his daughter gets old, though his son gets old, he does not steer them wrong."
    },
    "99": {
        "startTime": 940.0,
        "endTime": 943.5,
        "transcript": "Waten qanrucimauq taqsuunaku.",
        "translation": "It's said that we should not stop [caring for them]."
    },
    "100": {
        "startTime": 943.6,
        "endTime": 950.5,
        "transcript": "Tau͡gken makut aipamta ayallra man'a wangkutni arenqianaqluni cakneq.",
        "translation": "However, the way our counterparts go is very unsuitable to us."
    },
    "101": {
        "startTime": 951.9,
        "endTime": 959.5,
        "transcript": "Maa-i makut wani elitnaurat tamarmeng cakenriraitkut ciulirnerni.",
        "translation": "Now, all of these students disregard us elders."
    },
    "102": {
        "startTime": 960.8,
        "endTime": 967.0,
        "transcript": "Makut tau͡gaam kalikat nallunrilketeng kiingita usvikluki ilumun.",
        "translation": "They only trust in the wisdom of the books that they know, truly."
    },
    "103": {
        "startTime": 968.9,
        "endTime": 974.0,
        "transcript": "Kingum yua ayuqucirtuqalriani tua-i nakqapiarmek kiuluni.",
        "translation": "A child of the next generation talks back straight away when instructed."
    },
    "104": {
        "startTime": 975.0,
        "endTime": 983.5,
        "transcript": "Wall'u cangayugluni qanrutniluni, kituggniluni, kitugtengnaqniluni.",
        "translation": "Or he is offended by instrucion when they are corrected."
    },
    "105": {
        "startTime": 984.0,
        "endTime": 987.5,
        "transcript": "Quyanaqvaa tutgara'ar uum mat'umek qanqautamken.",
        "translation": "I am so thankful, my grandchild, that I'm telling you this."
    },
    "106": {
        "startTime": 989.4,
        "endTime": 993.5,
        "transcript": "Wii pikenritaqa. Nutem piuguq avaken ayagluni.",
        "translation": "It's not mine. It's ancient from long ago."
    },
    "107": {
        "startTime": 994.0,
        "endTime": 1001.0,
        "transcript": "Makut wani wangkuta nallunrilkengaput quli'irnek ayagluteng avaken piugut.",
        "translation": "What we know here is from ancient legends."
    },
    "108": {
        "startTime": 1001.5,
        "endTime": 1010.0,
        "transcript": "Kiituani yuugukut, yuurtut. Kiituani unuamek tekitut tayima maa-i umyuaqesteḿeggnun.",
        "translation": "Eventually we're alive, they are born. Eventually, they've come to those who remember them."
    },
    "109": {
        "startTime": 1016.0,
        "endTime": 1017.0,
        "transcript": "Quyanaqvaa.",
        "translation": "Thank you very much."
    },
    "110": {
        "startTime": 1017.8,
        "endTime": 1021.0,
        "transcript": "Quyanarquten elpet, alapen'errlua-ll' maavet itrama.",
        "translation": "I should dearly thank you, also because I'm surprised to have come in here."
    }
};